(function() {

// Add CSS for disabled filters
const style = document.createElement('style');
style.textContent = `
  .all-filters label.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    color: #999;
  }
  
  .all-filters label.disabled input[type="checkbox"] {
    cursor: not-allowed;
    pointer-events: none;
  }
  
  .mobile-filters-panel label.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    color: #999;
  }
  
  .mobile-filters-panel label.disabled input[type="checkbox"] {
    cursor: not-allowed;
    pointer-events: none;
  }
`;
document.head.appendChild(style);

// 1) Boilerplate & dataset parsing
  const token = window.__STOREFRONT_ACCESS_TOKEN__;
  const container = document.querySelector('.all-filters');
  if (! container) {
    console.error('No .all-filters container found');
    return;
  }

  const handle = container.dataset.collectionHandle;
  const rawTags = container.dataset.currentTags; // e.g. '["winter","formal"]'
  const activeTags = rawTags && rawTags !== 'null'
    ? JSON.parse(rawTags)
    : []; // ["winter","formal",…]
  const endpoint = '/api/2025-01/graphql.json';

  // Get server-side collection filters for accurate counts
  const rawCollectionFilters = container.dataset.collectionFilters;
  const rawCollectionFiltersParsed = rawCollectionFilters && rawCollectionFilters !== 'null'
    ? JSON.parse(rawCollectionFilters)
    : [];
  let currentServerFilters = normalizeAndCombineFilters(rawCollectionFiltersParsed);

// Function to parse URL parameters
  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    const filters = [];

// Get all filter parameters
    params.getAll('filter').forEach(filter => {
      if (filter.includes(':')) { // Handle metafield filters (e.g., filter_color:Grey)
        const [key, value] = filter.split(':');
        filters.push({
          productMetafield: {
            namespace: "custom",
            key: key,
            value: decodeURIComponent(value)
          }
        });
      } else { // Handle tag filters (e.g., Reda)
        filters.push({tag: filter});
      }
    });

    // Parse product type filter from URL (e.g., product_type=Suits)
    const productType = params.get('product_type');
    if (productType) {
      filters.push({ productType: productType });
    }

    // Parse price filters from URL (e.g., filter[p][price][min]=500)
    const priceMin = params.get('filter[p][price][min]');
    const priceMax = params.get('filter[p][price][max]');
  if (priceMin || priceMax) {
      const minVal = priceMin ? parseFloat(priceMin) : NaN;
      const maxVal = priceMax ? parseFloat(priceMax) : NaN;
      const minNum = isNaN(minVal) ? 0 : Math.round(minVal * 100) / 100;
      const maxNum = isNaN(maxVal) ? 999999 : Math.round(maxVal * 100) / 100;
      filters.push({ price: { min: minNum, max: maxNum } });
      
      // Also set the input values from URL
      const minInput = document.getElementById('js-price-min');
      const maxInput = document.getElementById('js-price-max');
      const mobileMinInput = document.getElementById('mobile-js-price-min');
      const mobileMaxInput = document.getElementById('mobile-js-price-max');
      if (minInput && !isNaN(minVal)) minInput.value = minVal;
      if (maxInput && !isNaN(maxVal)) maxInput.value = maxVal;
      if (mobileMinInput && !isNaN(minVal)) mobileMinInput.value = minVal;
      if (mobileMaxInput && !isNaN(maxVal)) mobileMaxInput.value = maxVal;
    }

    return filters;
  }

// Combine URL params with active tags
  const urlFilters = getUrlParams();
  
  // activeTags are navigation tags (sub-categories) from Shopify's tag system
  // These should always be preserved and used as the base for filtering
  const navigationTags = activeTags.map(tag => ({tag}));
  
  // combinedFilters includes both navigation tags and metafield filters
  const combinedFilters = [
    ... navigationTags,
    ... urlFilters
  ];

// 2) GraphQL queries
  const facetQuery = `
    query getCollectionFilters($handle: String!, $filters: [ProductFilter!]) {
      collectionByHandle(handle: $handle) {
        products(first: 250, filters: $filters) {
          edges {
            node {
              productType
              tags
              availableForSale
              priceRange { minVariantPrice { amount } }
              images(first:1) {
                edges { node { url } }
              }
              variants(first:1) {
                edges { node { priceV2 { amount } compareAtPriceV2 { amount } } }
              }
              metafields(identifiers: [
                {namespace: "custom", key: "filter_material"},
                {namespace: "custom", key: "filter_color"},
                {namespace: "custom", key: "filter_design"}
              ]) {
                key
                value
              }
            }
          }
          filters {
            label
            type
            values { 
              label 
              count 
              input
            }
          }
        }
      }
    }`;

  const productQuery = `
    query getFilteredProducts($handle: String!, $filters: [ProductFilter!]) {
      collectionByHandle(handle: $handle) {
        products(first:250, filters: $filters) {
          edges {
            node {
              title
              handle
              productType
              availableForSale
              tags
              priceRange { minVariantPrice { amount } }
              variants(first:5) {
                edges { node { availableForSale quantityAvailable priceV2 { amount } compareAtPriceV2 { amount } } }
              }
              images(first:2) {
                edges { node { url } }
              }
              metafields(identifiers: [
                {namespace: "custom", key: "filter_material"},
                {namespace: "custom", key: "filter_color"},
                {namespace: "custom", key: "filter_design"}
              ]) {
                key
                value
              }
            }
          }
        }
      }
    }`;

// Low-stock badge: mirrors snippets/product-grid-item.liquid, which reads
  // `selected_or_first_available_variant.inventory_quantity` and shows the marker
  // for 0 < qty < 15. `quantityAvailable` is null on untracked variants, so those
  // never qualify. Returns '' when the badge should not render.
  const LOW_STOCK_THRESHOLD = 15;
  function lowStockMarkup(node) {
    const variants = (node.variants?.edges || []).map(e => e.node);
    if (!variants.length) return '';
    const variant = variants.find(v => v.availableForSale) || variants[0];
    const qty = variant.quantityAvailable;
    if (typeof qty !== 'number' || qty <= 0 || qty >= LOW_STOCK_THRESHOLD) return '';
    return '<span class="low-stock_marker">Low on stock</span>';
  }

  // 3) Fetch & render facet filters AND initial products
  const filterVariables = {
    handle,
    filters: combinedFilters
  };

  // Determine if we need to fetch products via GraphQL
  // Always fetch for accurate counts; update display later based on active filters
  const shouldFetchProducts = true;
  const shouldUpdateDisplay = urlFilters.length > 0; // URL-driven metafield filters
  
  // Only show loading if we have URL metafield filters
  if (urlFilters.length > 0) {
    const grid = document.querySelector('.product-grid');
    if (grid) {
      grid.classList.add('is-loading');
    }
  }

  // Always fetch facets to get filter options, but only fetch products if needed
  const promises = [
    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({query: facetQuery, variables: filterVariables})
    })
  ];
  
  if (shouldFetchProducts) {
    promises.push(
      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({query: productQuery, variables: filterVariables})
      })
    );
  }

  Promise.all(promises).then(responses => {
    const facetResponse = responses[0];
    const productResponse = shouldFetchProducts ? responses[1] : null;
    
    return Promise.all([
      facetResponse.json(),
      productResponse ? productResponse.json() : Promise.resolve(null)
    ]);
  })
  .then(([facetData, productData]) => {
    // Handle facet data
    const {data: facetResponse, errors: facetErrors} = facetData;
    if (facetErrors) {
      const g = document.querySelector('.product-grid');
      if (g) g.classList.remove('is-loading');
      console.error('GraphQL errors:', facetErrors);
      return;
    }

    if (!facetResponse?.collectionByHandle?.products?.filters) {
      const g = document.querySelector('.product-grid');
      if (g) g.classList.remove('is-loading');
      console.error('Invalid facet data structure:', facetResponse);
      return;
    }

    // Make facet data available globally for server-rendered counts and update current filters snapshot
    window.facetData = facetResponse;
    if (facetResponse?.collectionByHandle?.products?.filters) {
      currentServerFilters = normalizeAndCombineFilters(facetResponse.collectionByHandle.products.filters);
    }

    // Handle product data (only if we fetched it)
    if (shouldFetchProducts && productData) {
      const {data: productResponse, errors: productErrors} = productData;
      if (productErrors) {
        const g = document.querySelector('.product-grid');
        if (g) g.classList.remove('is-loading');
        console.error('GraphQL errors:', productErrors);
        return;
      }

      if (!productResponse?.collectionByHandle?.products?.edges) {
        const g = document.querySelector('.product-grid');
        if (g) g.classList.remove('is-loading');
        console.error('Invalid product data structure:', productResponse);
        return;
      }
    }

    // Process facet response
    const allProducts = facetResponse.collectionByHandle.products.edges;
    const filters = normalizeAndCombineFilters(facetResponse.collectionByHandle.products.filters);

    // When viewing a tagged collection (e.g. /collections/all/FW25), filter products by activeTags
    // so counts and product type options reflect only the tagged subset
    const products = activeTags.length > 0 && allProducts?.length > 0
      ? allProducts.filter(({node}) => node.tags && activeTags.some(tag =>
          node.tags.some(t => (t || '').toLowerCase() === (tag || '').toLowerCase())
        ))
      : (allProducts || []);

    // Get available filter values from actual products (tag-filtered when applicable)
    const availableFilters = {
      material: new Set(),
      color: new Set(),
      design: new Set(),
      productType: new Set()
    };

    // First, collect actual metafield values and product types from products
    if (products && products.length > 0) {
      products.forEach(({node}) => {
        if (node.productType) {
          const pt = node.productType.trim();
          if (pt && !pt.toLowerCase().includes('samples') && !pt.toLowerCase().includes('services')) {
            availableFilters.productType.add(pt);
          }
        }
        if (node.metafields && Array.isArray(node.metafields)) {
          node.metafields.forEach(metafield => {
            if (metafield && metafield.value) {
              let values;
              
              // Handle JSON-encoded values (like "[\"Wool & Linen & Silk\"]")
              try {
                const parsed = JSON.parse(metafield.value);
                if (Array.isArray(parsed)) {
                  values = parsed;
                } else {
                  values = metafield.value.split(',').map(v => v.trim());
                }
              } catch (e) {
                // If JSON parsing fails, treat as comma-separated
                values = metafield.value.split(',').map(v => v.trim());
              }
              
              values.forEach(value => {
                if (value) {
                  switch (metafield.key) {
                    case 'filter_material': availableFilters.material.add(value);
                      break;
                    case 'filter_color': availableFilters.color.add(value);
                      break;
                    case 'filter_design': availableFilters.design.add(value);
                      break;
                  }
                }
              });
            }
          });
        }
      });
    }

    // Process filters and show them based on whether we're in a tag-filtered view
    filters.forEach(filter => {
      // Map filter labels to their corresponding container IDs
      const filterMap = {
        'Material': 'fabric-filters',
        'Color': 'color-filters',
        'Design': 'pattern-filters',
        'Price': 'price-filters'
      };

      const mobileFilterMap = {
        'Material': 'mobile-material-filters',
        'Color': 'mobile-color-filters',
        'Design': 'mobile-design-filters',
        'Price': 'mobile-price-filters'
      };

      const filterId = filterMap[filter.label];
      const mobileFilterId = mobileFilterMap[filter.label];
      if (!filterId) {
        return;
      }

      // Find the filter container using the correct ID
      const filterContainer = container.querySelector(`#${filterId}`);
      if (!filterContainer) {
        return;
      }

      // Find the ul element within the container
      const ul = filterContainer.querySelector('ul');
      if (!ul) {
        return;
      }

      // Clear existing filters
      ul.innerHTML = '';

      // For LIST type filters
      if (filter.type === 'LIST') {
        // Calculate accurate counts for this filter type
        const filterType = filter.label.toLowerCase();
        const checkedFilters = getCheckedFilters();
        const excludeFilters = checkedFilters.filter(f => f.type !== filterType);
        
        // Always use GraphQL data for counts since we're fetching it
        const counts = calculateFilterCounts(products, activeTags, excludeFilters);
        
        filter.values.forEach(value => {
          try {
            const input = JSON.parse(value.input);
            const metafield = input.productMetafield;

            if (!metafield || !metafield.value) {
              return;
            }

            // Split the metafield value into an array
            let metafieldValues;
            try {
              const parsed = JSON.parse(metafield.value);
              metafieldValues = Array.isArray(parsed) ? parsed : metafield.value.split(',').map(v => v.trim());
            } catch (e) {
              metafieldValues = metafield.value.split(',').map(v => v.trim());
            }

            // If we're in a tag-filtered view (activeTags has values), only show filters that exist in current products
            // If we're in the main collection (no activeTags), show all filters that have values
            let shouldShow = false;

            if (activeTags.length > 0) { // In tag-filtered view: only show if any of the values exist in current products
              switch (metafield.key) {
                case 'filter_material': shouldShow = metafieldValues.some(v => availableFilters.material.has(v));
                  break;
                case 'filter_color': shouldShow = metafieldValues.some(v => availableFilters.color.has(v));
                  break;
                case 'filter_design': shouldShow = metafieldValues.some(v => availableFilters.design.has(v));
                  break;
              }
            } else { // In main collection: show all filters that have values
              shouldShow = true;
            }

            if (shouldShow) {
              const li = document.createElement('li');
              
              // Check if this filter should be checked based on URL parameters
              const isChecked = urlFilters.some(f => {
                if (f.productMetafield?.key === metafield.key) {
                  // Split both values and check if any match
                  let urlValues;
                  try {
                    const parsed = JSON.parse(f.productMetafield.value);
                    urlValues = Array.isArray(parsed) ? parsed : f.productMetafield.value.split(',').map(v => v.trim());
                  } catch (e) {
                    urlValues = f.productMetafield.value.split(',').map(v => v.trim());
                  }
                  return urlValues.some(urlVal => metafieldValues.includes(urlVal));
                }
                return false;
              });
              
              // Calculate the count for this specific filter value using server-side collection filters
              let filterCount = 0;
              
              // Find the corresponding server-side filter
              const serverSideFilter = (currentServerFilters || []).find(f => 
                f && f.label && (
                  f.label.toLowerCase() === filterType || 
                  (filterType === 'material' && f.label === 'Material') ||
                  (filterType === 'color' && f.label === 'Color') ||
                  (filterType === 'design' && f.label === 'Design')
                )
              );
              
              if (serverSideFilter) {
                // Find the corresponding server-side value by matching the label
                const serverSideValue = serverSideFilter.values.find(v => 
                  (v.label || '').trim().toLowerCase() === (value.label || '').trim().toLowerCase()
                );
                
                if (serverSideValue) {
                  filterCount = serverSideValue.count || 0;
                }
              }
              
              // Fallback to client-side count if server-side data not available
              if (filterCount === 0) {
                const countKey = filterType === 'material' ? 'material' : 
                                filterType === 'color' ? 'color' : 
                                filterType === 'design' ? 'design' : null;
                
                if (countKey) {
                  metafieldValues.forEach(val => {
                    if (counts[countKey] && counts[countKey][val]) {
                      filterCount += counts[countKey][val];
                    }
                  });
                }
              }
              
              // Determine if filter should be disabled (count = 0)
              const isDisabled = filterCount === 0;
              
              // Check if another filter of the same type is already selected
              const checkedFilters = getCheckedFilters();
              const hasOtherFilterOfSameType = checkedFilters.some(filter => 
                filter.type === filterType && filter.value !== metafield.value
              );
              
              // Disable if count is 0 OR if another filter of the same type is selected
              const shouldDisable = isDisabled || hasOtherFilterOfSameType;
              const disabledClass = shouldDisable ? 'disabled' : '';
              const disabledAttr = shouldDisable ? 'disabled' : '';
              
              li.innerHTML = `
                <label class="${disabledClass}">
                  <input type="checkbox" 
                         data-filter-type="${filter.label.toLowerCase()}" 
                         data-filter-value="${metafield.value}"
                         ${isChecked ? 'checked' : ''}
                         ${disabledAttr}>
                    ${value.label} (${filterCount})
                </label>
              `;
              ul.appendChild(li);
              
              // Also add to mobile filters
              const mobileUl = document.querySelector(`#${mobileFilterId} ul`);
              if (mobileUl) {
                const mobileLi = document.createElement('li');
                mobileLi.innerHTML = `
                  <label class="${disabledClass}">
                    <input type="checkbox" 
                           data-filter-type="${filter.label.toLowerCase()}" 
                           data-filter-value="${metafield.value}"
                           ${isChecked ? 'checked' : ''}
                           ${disabledAttr}>
                      ${value.label} (${filterCount})
                    </label>
                `;
                mobileUl.appendChild(mobileLi);
              }
            }
          } catch (e) {
            console.error(`Error processing filter value: ${value.label}`, e);
          }
        });
      } else if (filter.type === 'PRICE_RANGE') { // Handle price range filter
        const priceInputs = filterContainer.querySelector('.price-inputs');
        if (priceInputs && products && products.length > 0) {
          const minPrice = products.reduce((min, {node}) => {
            const price = parseFloat(node.priceRange.minVariantPrice.amount);
            return price < min ? price : min;
          }, Infinity);

          const maxPrice = products.reduce((max, {node}) => {
            const price = parseFloat(node.priceRange.minVariantPrice.amount);
            return price > max ? price : max;
          }, 0);

          const minInput = priceInputs.querySelector('#js-price-min');
          const maxInput = priceInputs.querySelector('#js-price-max');

          if (minInput) minInput.placeholder = minPrice;
          if (maxInput) maxInput.placeholder = maxPrice;
          
          // Also set mobile price placeholders
          const mobileMinInput = document.getElementById('mobile-js-price-min');
          const mobileMaxInput = document.getElementById('mobile-js-price-max');
          
          if (mobileMinInput) mobileMinInput.placeholder = minPrice;
          if (mobileMaxInput) mobileMaxInput.placeholder = maxPrice;
        }
      }
    });

    // Build product type slider (SuitSupply-style scrollable cards) - only source for product type selection
    const productTypeSliderTrack = document.querySelector('#product-type-slider .product-type-slider__track');
    const productTypeSlider = document.getElementById('product-type-slider');
    // A slider with a single card offers no choice - the template already skips
    // it for single-type collections, this catches the tag-scoped views where
    // the products in scope turn out to share one type.
    if (productTypeSlider && availableFilters.productType.size < 2) {
      productTypeSlider.hidden = true;
      if (productTypeSliderTrack) productTypeSliderTrack.innerHTML = '';
    } else if (availableFilters.productType.size > 1 && productTypeSliderTrack) {
      if (productTypeSlider) productTypeSlider.hidden = false;
      const sortedProductTypes = Array.from(availableFilters.productType).sort((a, b) => a.localeCompare(b));
      const productTypeFromUrl = urlFilters.find(f => f.productType);
      const excludeProductType = productTypeFromUrl
        ? [{ type: 'producttype', value: productTypeFromUrl.productType }]
        : [];
      const counts = calculateFilterCounts(products, activeTags, excludeProductType);

      // Build map: productType -> first product image URL
      const productTypeImages = {};
      products.forEach(({node}) => {
        const pt = node.productType?.trim();
        if (pt && !productTypeImages[pt]) {
          const imgEdge = node.images?.edges?.[0];
          if (imgEdge?.node?.url) productTypeImages[pt] = imgEdge.node.url;
        }
      });

      productTypeSliderTrack.innerHTML = '';
      sortedProductTypes.forEach(pt => {
        const filterCount = (counts.productType && counts.productType[pt]) || 0;
        const isActive = productTypeFromUrl && productTypeFromUrl.productType === pt;
        const isDisabled = filterCount === 0;
        const imgUrl = productTypeImages[pt] || '';

        const card = document.createElement('button');
        card.type = 'button';
        card.className = `product-type-slider__card${isActive ? ' is-active' : ''}${isDisabled ? ' is-disabled' : ''}`;
        card.dataset.filterType = 'producttype';
        card.dataset.filterValue = pt;
        card.disabled = isDisabled;
        card.setAttribute('aria-pressed', isActive);
        card.setAttribute('aria-label', `${pt} (${filterCount} products)`);
        card.innerHTML = `
          <span class="product-type-slider__card-image" ${imgUrl ? `style="background-image:url(${imgUrl.replace(/"/g, '&quot;')})"` : ''}></span>
          <span class="product-type-slider__card-label-wrapper">
            <span class="product-type-slider__card-label">${pt}</span>
            <span class="product-type-slider__card-count">${filterCount}</span>
          </span>
        `;
        productTypeSliderTrack.appendChild(card);

        if (!isDisabled) {
          card.addEventListener('click', () => {
            const wasActive = card.classList.contains('is-active');
            productTypeSliderTrack.querySelectorAll('.product-type-slider__card').forEach(c => c.classList.remove('is-active'));
            productTypeSliderTrack.querySelectorAll('.product-type-slider__card').forEach(c => c.setAttribute('aria-pressed', 'false'));
            if (!wasActive) {
              card.classList.add('is-active');
              card.setAttribute('aria-pressed', 'true');
            } else {
              /* Remove focus after deselect so no lingering focus styling */
              card.blur();
            }
            applyFilters();
          });
        }
      });
    }

    // Process product response and update the product grid
    if (shouldUpdateDisplay && productData) {
      const productEdges = productData.data?.collectionByHandle?.products?.edges;
      const grid = document.querySelector('.product-grid');
      if (grid) grid.classList.remove('is-loading');

      // Apply client-side filtering
      let filteredEdges = productEdges;
      
      // navigation tags
      if (activeTags.length > 0) {
        filteredEdges = filteredEdges.filter(({node}) => {
          // Check if the product has any of the navigation tags
          return node.tags && activeTags.some(tag =>
            node.tags.some(t => (t || '').toLowerCase() === (tag || '').toLowerCase())
          );
        });
      }
      
      // Product type filter from slider
      const sliderProductType = getActiveProductTypeFromSlider();
      if (sliderProductType) {
        filteredEdges = filteredEdges.filter(({node}) => node.productType && node.productType === sliderProductType);
      }

      // Metafield filters from checkboxes
      const checkedInputs = container.querySelectorAll('input[type="checkbox"]:checked');
      checkedInputs.forEach(cb => {
        const filterType = cb.dataset.filterType;
        const filterValue = cb.dataset.filterValue;
        
        if (filterType && filterValue) {
          filteredEdges = filteredEdges.filter(({node}) => {
            if (node.metafields && Array.isArray(node.metafields)) {
              const metafield = node.metafields.find(m => m && m.key === `filter_${filterType}`);
              if (metafield && metafield.value) {
                let metafieldValues;
                let filterValues;
                
                try {
                  const parsed = JSON.parse(metafield.value);
                  metafieldValues = Array.isArray(parsed) ? parsed : metafield.value.split(',').map(v => v.trim());
                } catch (e) {
                  metafieldValues = metafield.value.split(',').map(v => v.trim());
                }
                
                try {
                  const parsed = JSON.parse(filterValue);
                  filterValues = Array.isArray(parsed) ? parsed : filterValue.split(',').map(v => v.trim());
                } catch (e) {
                  filterValues = filterValue.split(',').map(v => v.trim());
                }
                
                return filterValues.some(fv => metafieldValues.includes(fv));
              }
            }
            return false;
          });
        }
      });

      if (! filteredEdges.length) {
        grid.innerHTML = '<li class="no-results">No products found.</li>';
        return;
      }

      // Rebuild each <li> using your original markup
      grid.innerHTML = filteredEdges.map(({node}) => {
        const variantEdge = node.variants.edges[0];
        const variant = variantEdge?.node || {};
        const priceAmount = variant.priceV2?.amount ?? node.priceRange.minVariantPrice.amount;
        const compareAmount = variant.compareAtPriceV2?.amount ?? null;
        const onSale = compareAmount && parseFloat(compareAmount) > parseFloat(priceAmount);
        const soldOut = !node.availableForSale;
        const imgs = node.images.edges.map(e => e.node.url);
        const img1 = imgs[0] || '/path/to/placeholder.png';
        const img2 = imgs[1] || img1;

        return `
<li class="product-grid-item${soldOut ? ' sold-out' : ''}${onSale ? ' on-sale' : ''}">
  <div class="prod-image-wrap">
    ${window.PantsEvent && window.PantsEvent.badge ? window.PantsEvent.badge(node.tags) : ''}
    ${onSale ? `<span class="discount-marker">
           ${Math.round((parseFloat(compareAmount) - parseFloat(priceAmount)) / parseFloat(compareAmount) * 100)}% OFF
         </span>` : ''}
    <div class="${soldOut ? 'soldout' : 'hide'}-marker">
      <span>Sold Out</span>
    </div>
    ${lowStockMarkup(node)}
    <div class="prod-quick-add">
      <a class="button" href="/products/${node.handle}">View Details</a>
    </div>
    <a href="/products/${node.handle}" class="small-link">
      <img src="${img1}" alt="${node.title}" class="lazyload first">
    </a>
    <img src="${img1}" alt="${node.title}" class="first large-image">
    <img src="${img2}" alt="${node.title}" class="second large-image">
  </div>
  <div class="prod-caption">
    <a href="/products/${node.handle}" title="${node.title}">
      <span>${node.title}</span>
    </a>
    <span class="prod-price">
      ${onSale ? `<s class="compare-at-price">€${compareAmount.replace(/\.00$/, '')}</s>` : ''}
      €${priceAmount.replace(/\.00$/, '')}
    </span>
  </div>
</li>`;
      }).join('');
    }

    // Update active filters display
    updateActiveFiltersDisplay();
    
    // Update filter counts using facet data (which includes all products)
    updateFilterCounts(facetData);
  }).catch(err => {
    const g = document.querySelector('.product-grid');
    if (g) g.classList.remove('is-loading');
    console.error('Error loading facets and products:', err);
  });

// 4) Utility to mark last-in-row dynamically
// function markLastInRow(grid) {
// const items = Array.from(grid.children);
// items.forEach(item => item.classList.remove('last-in-row'));
// items.forEach((item, i) => {
// const next = items[i + 1];
// if (!next || next.offsetTop > item.offsetTop) {
// item.classList.add('last-in-row');
// }
// });
// }

// Sync product type slider card active/disabled state with current filters
  function syncProductTypeSliderState() {
    const activeProductType = new URLSearchParams(window.location.search).get('product_type');
    const track = document.querySelector('#product-type-slider .product-type-slider__track');
    if (!track) return;
    track.querySelectorAll('.product-type-slider__card').forEach(card => {
      const value = card.dataset.filterValue;
      const isActive = activeProductType && value === activeProductType;
      card.classList.toggle('is-active', !!isActive);
      card.setAttribute('aria-pressed', isActive);
    });
  }

  // Get active product type from slider (primary source now that sidebar pill is removed)
  function getActiveProductTypeFromSlider() {
    const activeCard = document.querySelector('#product-type-slider .product-type-slider__card.is-active');
    return activeCard ? activeCard.dataset.filterValue : null;
  }

  // Function to apply filters
  function applyFilters() {
    const filters = [];

// Always preserve current navigation tags (from URL path)
    if (Array.isArray(activeTags)) {
      activeTags.forEach(tag => {
        if (!tag.includes('filter_')) {
          filters.push({tag});
        }
      });
    }

// Add metafield & option filters from checkboxes
    const checkedInputs = container.querySelectorAll('input[type="checkbox"]:checked');
    checkedInputs.forEach(cb => {
      const filterType = cb.dataset.filterType;
      const filterValue = cb.dataset.filterValue;

      if (filterType && filterValue) {
        filters.push({
          productMetafield: {
            namespace: "custom",
            key: `filter_${filterType}`,
            value: filterValue
          }
        });
      }
    });

    // Add product type filter from slider (primary source)
    const activeProductType = getActiveProductTypeFromSlider();
    if (activeProductType) {
      filters.push({ productType: activeProductType });
    }

// Price min/max - GraphQL requires Decimal (string format)
    const minInput = document.getElementById('js-price-min');
    const maxInput = document.getElementById('js-price-max');

    const minVal = parseFloat(minInput ?. value);
    const maxVal = parseFloat(maxInput ?. value);
    if (!isNaN(minVal) || !isNaN(maxVal)) {
      const minNum = isNaN(minVal) ? 0 : Math.round(minVal * 100) / 100;
      const maxNum = isNaN(maxVal) ? 999999 : Math.round(maxVal * 100) / 100;
      filters.push({ price: { min: minNum, max: maxNum } });
    }

    // Determine if we need to fetch products via GraphQL
    const hasMetafieldFilters = filters.some(f => f.productMetafield);
    const hasProductTypeFilter = filters.some(f => f.productType);
    const hasPriceFilter = filters.some(f => f.price);
    
    if (hasMetafieldFilters || hasProductTypeFilter || hasPriceFilter) {
      // Show loading state
      const grid = document.querySelector('.product-grid');
      if (grid) {
        grid.classList.add('is-loading');
      }
      // We have metafield filters, need to fetch products via GraphQL for client-side filtering
      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify(
          {
            query: productQuery,
            variables: {
              handle,
              filters
            }
          }
        )
      }).then(res => res.json()).then(json => {
        const grid = document.querySelector('.product-grid');
        if (grid) grid.classList.remove('is-loading');
        if (json.errors) {
          console.error('GraphQL product errors:', json.errors);
          return;
        }
        const edges = json?.data?.collectionByHandle?.products?.edges || [];

        // Apply client-side filtering
        let filteredEdges = edges;
        
        // navigation tags
        if (activeTags.length > 0) {
          filteredEdges = filteredEdges.filter(({node}) => {
            // Check if the product has any of the navigation tags
            return node.tags && activeTags.some(tag =>
              node.tags.some(t => (t || '').toLowerCase() === (tag || '').toLowerCase())
            );
          });
        }
        
        // Product type filter from slider
        const sliderProductType = getActiveProductTypeFromSlider();
        if (sliderProductType) {
          filteredEdges = filteredEdges.filter(({node}) => node.productType && node.productType === sliderProductType);
        }

        // Metafield filters from checkboxes
        const checkedInputs = container.querySelectorAll('input[type="checkbox"]:checked');
        checkedInputs.forEach(cb => {
          const filterType = cb.dataset.filterType;
          const filterValue = cb.dataset.filterValue;
          
          if (filterType && filterValue) {
            filteredEdges = filteredEdges.filter(({node}) => {
              if (node.metafields && Array.isArray(node.metafields)) {
                const metafield = node.metafields.find(m => m && m.key === `filter_${filterType}`);
                if (metafield && metafield.value) {
                  let metafieldValues;
                  let filterValues;
                  
                  try {
                    const parsed = JSON.parse(metafield.value);
                    metafieldValues = Array.isArray(parsed) ? parsed : metafield.value.split(',').map(v => v.trim());
                  } catch (e) {
                    metafieldValues = metafield.value.split(',').map(v => v.trim());
                  }
                  
                  try {
                    const parsed = JSON.parse(filterValue);
                    filterValues = Array.isArray(parsed) ? parsed : filterValue.split(',').map(v => v.trim());
                  } catch (e) {
                    filterValues = filterValue.split(',').map(v => v.trim());
                  }
                  
                  return filterValues.some(fv => metafieldValues.includes(fv));
                }
              }
              return false;
            });
          }
        });

        // Apply price filter on client as a safeguard to ensure UI updates immediately
        const minInput = document.getElementById('js-price-min');
        const maxInput = document.getElementById('js-price-max');
        const minVal = parseFloat(minInput ?. value);
        const maxVal = parseFloat(maxInput ?. value);
        if (!isNaN(minVal) || !isNaN(maxVal)) {
          filteredEdges = filteredEdges.filter(({node}) => {
            const variantEdge = node.variants ?. edges ?. [0];
            const displayPrice = parseFloat(
              variantEdge ?. node ?. priceV2 ?. amount ??
              node.priceRange ?. minVariantPrice ?. amount ?? '0'
            );
            const minOk = isNaN(minVal) ? true : displayPrice >= minVal;
            const maxOk = isNaN(maxVal) ? true : displayPrice <= maxVal;
            return minOk && maxOk;
          });
        }

        if (! filteredEdges.length) {
          grid.innerHTML = '<li class="no-results">No products found.</li>';
          return;
        }

// Rebuild each <li> using your original markup
        grid.innerHTML = filteredEdges.map(({node}) => {
          const variantEdge = node.variants.edges[0];
          const variant = variantEdge ?. node || {};
          const priceAmount = variant.priceV2 ?. amount ?? node.priceRange.minVariantPrice.amount;
          const compareAmount = variant.compareAtPriceV2 ?. amount ?? null;
          const onSale = compareAmount && parseFloat(compareAmount) > parseFloat(priceAmount);
          const soldOut = !node.availableForSale;
          const imgs = node.images.edges.map(e => e.node.url);
          const img1 = imgs[0] || '/path/to/placeholder.png';
          const img2 = imgs[1] || img1;

          return `
<li class="product-grid-item${
            soldOut
              ? ' sold-out'
              : ''
            }${
              onSale
                ? ' on-sale'
                : ''
              }">
  <div class="prod-image-wrap">
    ${window.PantsEvent && window.PantsEvent.badge ? window.PantsEvent.badge(node.tags) : ''}
    ${
                onSale
                  ? `<span class="discount-marker">
             ${
                    Math.round((parseFloat(compareAmount) - parseFloat(priceAmount)) / parseFloat(compareAmount) * 100)
                  }% OFF
           </span>`
                  : ''
                }
    <div class="${
                  soldOut
                    ? 'soldout'
                    : 'hide'
                  }-marker">
      <span>Sold Out</span>
    </div>
    ${lowStockMarkup(node)}
    <div class="prod-quick-add">
      <a class="button" href="/products/${
                    node.handle
                  }">View Details</a>
    </div>
    <a href="/products/${
                    node.handle
                  }" class="small-link">
      <img src="${img1}" alt="${
                    node.title
                  }" class="lazyload first">
    </a>
    <img src="${img1}" alt="${
                    node.title
                  }" class="first large-image">
    <img src="${img2}" alt="${
                    node.title
                  }" class="second large-image">
  </div>
  <div class="prod-caption">
    <a href="/products/${
                    node.handle
                  }" title="${
                    node.title
                  }">
      <span>${
                    node.title
                  }</span>
    </a>
    <span class="prod-price">
      ${
                    onSale
                      ? `<s class="compare-at-price">€${
                        compareAmount.replace(/\.00$/, '')
                      }</s>`
                      : ''
                    }
      €${
                      priceAmount.replace(/\.00$/, '')
                    }
    </span>
  </div>
</li>`;
        }).join('');

// Update URL to reflect current filters
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

// Clear existing filter params (but keep navigation tags in URL path)
        params.delete('filter');
        params.delete('filter[p][price][min]');
        params.delete('filter[p][price][max]');
        params.delete('product_type');

// Add metafield filters and product type to query parameters
        filters.forEach(filter => {
          if (filter.productMetafield) {
            params.append('filter', `${filter.productMetafield.key}:${filter.productMetafield.value}`);
          }
          if (filter.productType) {
            params.set('product_type', filter.productType);
          }
          // Add price filters to query parameters
          if (filter.price) {
            if (filter.price.min && filter.price.min !== "0.00") {
              params.set('filter[p][price][min]', parseFloat(filter.price.min).toString());
            }
            if (filter.price.max && filter.price.max !== "999999.00") {
              params.set('filter[p][price][max]', parseFloat(filter.price.max).toString());
            }
          }
          // Note: We don't add tag filters to query params as they should stay in the URL path
        });

// Build the URL path with navigation tags
        let urlPath = url.pathname;
        
        // If we have navigation tags, they should be in the URL path
        const navigationTagFilters = filters.filter(f => f.tag);
        if (navigationTagFilters.length > 0) {
          // Check if the current path already has the navigation tag
          const pathParts = urlPath.split('/');
          const currentTag = pathParts[pathParts.length - 1];
          
          if (currentTag !== navigationTagFilters[0].tag) {
            // Remove any existing tags from the path and add current ones
            const collectionPart = pathParts.slice(0, -1).join('/'); // Remove the last part (current tag)
            urlPath = `${collectionPart}/${navigationTagFilters[0].tag}`; // Use the first navigation tag
          }
        } else {
          // No navigation tags, ensure we're at the main collection
          const pathParts = urlPath.split('/');
          if (pathParts.length > 3) { // More than /collections/handle/
            const collectionPart = pathParts.slice(0, -1).join('/'); // Remove the tag
            urlPath = collectionPart;
          }
        }

// Update URL without reloading
        const newUrl = params.toString() ? `${urlPath}?${params.toString()}` : urlPath;
        window.history.pushState({}, '', newUrl);

// Update active filters display
        updateActiveFiltersDisplay();
        syncProductTypeSliderState();

        // Refetch facet data with current filters so other filter counts reflect the selection
        fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token
          },
          body: JSON.stringify({ query: facetQuery, variables: { handle, filters } })
        })
        .then(res => res.json())
        .then(facetJson => {
          if (facetJson.errors) {
            console.error('GraphQL facet errors:', facetJson.errors);
            return;
          }
          window.facetData = facetJson.data;
          if (facetJson?.data?.collectionByHandle?.products?.filters) {
            currentServerFilters = normalizeAndCombineFilters(facetJson.data.collectionByHandle.products.filters);
          }
          updateFilterCounts(facetJson);
        })
        .catch(err => console.error('Error refreshing facet data after filter apply:', err));
      }).catch(err => {
        const g = document.querySelector('.product-grid');
        if (g) g.classList.remove('is-loading');
        console.error('Error fetching products:', err);
      });
    } else {
      // No metafield/price/productType filters - fetch products to update grid (e.g. when deselecting product type)
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      params.delete('filter');
      let urlPath = url.pathname;
      const navigationTagFilters = filters.filter(f => f.tag);
      if (navigationTagFilters.length > 0) {
        const pathParts = urlPath.split('/');
        const currentTag = pathParts[pathParts.length - 1];
        if (currentTag !== navigationTagFilters[0].tag) {
          const collectionPart = pathParts.slice(0, -1).join('/');
          urlPath = `${collectionPart}/${navigationTagFilters[0].tag}`;
        }
      } else {
        const pathParts = urlPath.split('/');
        if (pathParts.length > 3) {
          const collectionPart = pathParts.slice(0, -1).join('/');
          urlPath = collectionPart;
        }
      }
      
      // Check if we're going back to the full collection (no filters, no navigation tags)
      const hasAnyFilters = filters.length > 0;
      const hasNavigationTags = navigationTagFilters.length > 0;
      const hasMetafieldFilters = filters.some(f => f.productMetafield);
      
      // If we're going back to the full collection and we were previously showing filtered products,
      // refresh the page to get the server-side rendered products
      if (!hasAnyFilters && !hasNavigationTags && window.location.search.includes('filter=')) {
        // We're clearing all filters and going back to full collection, refresh the page
        const newUrl = urlPath;
        window.location.href = newUrl;
        return;
      }
      
      // Clear existing filter params (but keep navigation tags in URL path)
      params.delete('filter');
      params.delete('filter[p][price][min]');
      params.delete('filter[p][price][max]');
      params.delete('product_type');

      // Add metafield and price filters to query parameters if present
      filters.forEach(filter => {
        if (filter.productMetafield) {
          params.append('filter', `${filter.productMetafield.key}:${filter.productMetafield.value}`);
        }
        if (filter.price) {
          if (filter.price.min != null && filter.price.min !== 0) {
            params.set('filter[p][price][min]', String(filter.price.min));
          }
          if (filter.price.max != null && filter.price.max !== 999999) {
            params.set('filter[p][price][max]', String(filter.price.max));
          }
        }
      });

      // Update URL without reloading
      const newUrl = params.toString() ? `${urlPath}?${params.toString()}` : urlPath;
      window.history.pushState({}, '', newUrl);
      
      // Update active filters display
      updateActiveFiltersDisplay();
      syncProductTypeSliderState();
      
      // Show loading state
      const gridForElse = document.querySelector('.product-grid');
      if (gridForElse) {
        gridForElse.classList.add('is-loading');
      }
      
      // Fetch products and update grid (needed when deselecting product type)
      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: productQuery, variables: { handle, filters } })
      })
      .then(res => res.json())
      .then(json => {
        if (json.errors) return;
        let filteredEdges = json?.data?.collectionByHandle?.products?.edges || [];
        if (activeTags.length > 0) {
          filteredEdges = filteredEdges.filter(({node}) =>
            node.tags && activeTags.some(tag =>
              node.tags.some(t => (t || '').toLowerCase() === (tag || '').toLowerCase())
            )
          );
        }
        const grid = document.querySelector('.product-grid');
        if (!grid) return;
        grid.classList.remove('is-loading');
        if (!filteredEdges.length) {
          grid.innerHTML = '<li class="no-results">No products found.</li>';
          return;
        }
        grid.innerHTML = filteredEdges.map(({node}) => {
          const variantEdge = node.variants?.edges?.[0];
          const variant = variantEdge?.node || {};
          const priceAmount = variant.priceV2?.amount ?? node.priceRange?.minVariantPrice?.amount ?? '0';
          const compareAmount = variant.compareAtPriceV2?.amount ?? null;
          const onSale = compareAmount && parseFloat(compareAmount) > parseFloat(priceAmount);
          const soldOut = !node.availableForSale;
          const imgs = node.images?.edges?.map(e => e.node.url) || [];
          const img1 = imgs[0] || '/path/to/placeholder.png';
          const img2 = imgs[1] || img1;
          return `<li class="product-grid-item${soldOut ? ' sold-out' : ''}${onSale ? ' on-sale' : ''}">
  <div class="prod-image-wrap">
    ${window.PantsEvent && window.PantsEvent.badge ? window.PantsEvent.badge(node.tags) : ''}
    ${onSale ? `<span class="discount-marker">${Math.round((parseFloat(compareAmount) - parseFloat(priceAmount)) / parseFloat(compareAmount) * 100)}% OFF</span>` : ''}
    <div class="${soldOut ? 'soldout' : 'hide'}-marker"><span>Sold Out</span></div>
    ${lowStockMarkup(node)}
    <div class="prod-quick-add"><a class="button" href="/products/${node.handle}">View Details</a></div>
    <a href="/products/${node.handle}" class="small-link"><img src="${img1}" alt="${node.title}" class="lazyload first"></a>
    <img src="${img1}" alt="${node.title}" class="first large-image">
    <img src="${img2}" alt="${node.title}" class="second large-image">
  </div>
  <div class="prod-caption">
    <a href="/products/${node.handle}" title="${node.title}"><span>${node.title}</span></a>
    <span class="prod-price">${onSale ? `<s class="compare-at-price">€${(compareAmount || '').replace(/\.00$/, '')}</s>` : ''} €${(priceAmount || '').replace(/\.00$/, '')}</span>
  </div>
</li>`;
        }).join('');
      })
      .catch(() => {
        const g = document.querySelector('.product-grid');
        if (g) g.classList.remove('is-loading');
      });

      // Refetch facet data
      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: facetQuery, variables: { handle, filters } })
      })
      .then(res => res.json())
      .then(facetJson => {
        window.facetData = facetJson.data;
        updateFilterCounts(facetJson);
      })
      .catch(err => console.error('Error refreshing facet data:', err));
    }
  }

// Add event listeners for automatic filter application
  container.addEventListener('change', (e) => {
    if (e.target.matches('input[type="checkbox"]')) {
      applyFilters();
    }
  });

// Add debounced event listener for price inputs
  let priceTimeout;
  container.addEventListener('input', (e) => {
    if (e.target.matches('input[type="number"]')) {
      clearTimeout(priceTimeout);
      priceTimeout = setTimeout(() => {
        applyFilters();
      }, 500); // Wait 500ms after user stops typing
    }
  });

// Remove the apply button
  const applyButton = document.getElementById('js-apply-filters');
  if (applyButton) {
    applyButton.parentElement.remove();
  }

// Function to update active filters display
  function updateActiveFiltersDisplay() {
    const activeFiltersList = document.querySelector('#collection-controls .desktop-active-filters .active-filters-list');
    const mobileActiveFiltersList = document.querySelector('.mobile-filters-panel .active-filters-list');
    
    if (! activeFiltersList && ! mobileActiveFiltersList) return;
    

    const filters = [];

// Add navigation tags (sub-categories) to active filters display
    if (Array.isArray(activeTags) && activeTags.length > 0) {
      activeTags.forEach(tag => {
        filters.push({type: 'navigation', value: tag});
      });
    }

// Get checked checkboxes (metafield filters only)
    const checkedInputs = container.querySelectorAll('input[type="checkbox"]:checked');
    checkedInputs.forEach(cb => {
      const filterType = cb.dataset.filterType;
      const filterValue = cb.dataset.filterValue;
      if (filterType && filterValue) {
        filters.push({type: filterType, value: filterValue});
      }
    });

    // Get product type from slider
    const activeProductType = getActiveProductTypeFromSlider();
    if (activeProductType) {
      filters.push({type: 'producttype', value: activeProductType});
    }

// Get price range
    const minInput = document.getElementById('js-price-min');
    const maxInput = document.getElementById('js-price-max');
    const minVal = parseFloat(minInput ?. value);
    const maxVal = parseFloat(maxInput ?. value);

    if (!isNaN(minVal) || !isNaN(maxVal)) {
      filters.push({
        type: 'price',
          value: `${
          isNaN(minVal)
            ? '0'
            : minVal
          } - ${
            isNaN(maxVal)
              ? '∞'
              : maxVal
            }`
      });
    }

// Create active filter HTML
    const activeFilterHTML = filters.map(filter => `
      <div class="active-filter-tag">
        <span class="filter-value">${
      filter.value
    }</span>
        <span class="remove-filter" data-filter-type="${
      filter.type
    }" data-filter-value="${
      filter.value
    }">×</span>
      </div>
    `).join('');

// Update desktop active filters display
    if (activeFiltersList) {
      activeFiltersList.innerHTML = activeFilterHTML;
    }

// Update mobile active filters display
    if (mobileActiveFiltersList) {
      mobileActiveFiltersList.innerHTML = activeFilterHTML;
    }

// Show/hide active filters section
    const activeFiltersSection = document.querySelector('#collection-controls .desktop-active-filters');
    const mobileActiveFiltersSection = document.getElementById('mobile-active-filters');
    
    if (activeFiltersSection) {
      activeFiltersSection.style.display = filters.length > 0
        ? 'block'
        : 'none';
    }
    
    if (mobileActiveFiltersSection) {
      mobileActiveFiltersSection.style.display = filters.length > 0
        ? 'block'
        : 'none';
    }
  }

// Add event listeners for active filters
  document.addEventListener('click', (e) => {
    // Accordion behavior: only one dropdown open at a time (desktop)
    const pillHeader = e.target.closest('.filter-side-title');
    if (pillHeader && window.innerWidth > 768) {
      const pill = pillHeader.closest('.filter-side');
      if (pill) {
        const siblings = pill.parentElement.querySelectorAll('.filter-side');
        siblings.forEach(sib => {
          if (sib !== pill) {
            sib.classList.remove('active');
            const sibH4 = sib.querySelector('.filter-side-title h4');
            if (sibH4) sibH4.classList.remove('selected');
          }
        });
        pill.classList.toggle('active');
        const h4 = pill.querySelector('.filter-side-title h4');
        if (h4) h4.classList.toggle('selected');
      }
    }

    // Toggle Sort By dropdown
    const sortLabel = e.target.closest('#collection-sortable .collection-sorter label');
    if (sortLabel) {
      const sorter = sortLabel.closest('.collection-sorter');
      const menu = sorter ?. querySelector('.sort-by');
      if (menu) {
        const isOpen = menu.style.display === 'block';
        menu.style.display = isOpen ? 'none' : 'block';
      }
    }

    // Choose a sort option
    const sortOption = e.target.closest('#collection-sortable .collection-sorter .sort-by > div');
    if (sortOption) {
      const sortId = sortOption.id; // matches Shopify sort parameter ids
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      if (sortId) {
        params.set('sort_by', sortId);
      }
      const newUrl = params.toString() ? `${url.pathname}?${params.toString()}` : url.pathname;
      window.location.href = newUrl; // reload to let server render sorted products
      return;
    }

    // Click-outside to close Sort By
    const clickedInsideSorter = e.target.closest('#collection-sortable .collection-sorter');
    if (!clickedInsideSorter) {
      const menu = document.querySelector('#collection-sortable .collection-sorter .sort-by');
      if (menu) menu.style.display = 'none';
    }

    // Click-outside to close any open desktop filter dropdowns
    if (window.innerWidth > 768) {
      const clickedInsideFilter = e.target.closest('.filter-side') || e.target.closest('.filter-wrap');
      const clickedInsideMobilePanel = e.target.closest('.mobile-filters-panel');
      if (!clickedInsideFilter && !clickedInsideMobilePanel) {
        const openFilters = document.querySelectorAll('.filter-side.active');
        openFilters.forEach(f => {
          f.classList.remove('active');
          const h4 = f.querySelector('.filter-side-title h4');
          if (h4) h4.classList.remove('selected');
        });
      }
    }

// Handle individual filter removal
    if (e.target.classList.contains('remove-filter')) {
      const filterType = e.target.dataset.filterType;
      const filterValue = e.target.dataset.filterValue;

      if (filterType === 'navigation') {
        // For navigation tags, redirect to the main collection but preserve metafield filters
        const url = new URL(window.location.href);
        const pathParts = url.pathname.split('/');
        const collectionPart = pathParts.slice(0, -1).join('/'); // Remove the tag from path
        
        // Preserve existing metafield filters in query parameters
        const params = new URLSearchParams(url.search);
        const newUrl = params.toString() ? `${collectionPart}?${params.toString()}` : collectionPart;
        
        window.location.href = newUrl;
        return;
      } else if (filterType === 'price') { // Clear price inputs
        const minInput = document.getElementById('js-price-min');
        const maxInput = document.getElementById('js-price-max');
        if (minInput) 
          minInput.value = '';
        
        if (maxInput) 
          maxInput.value = '';
        
      } else if (filterType === 'producttype') { // Deselect product type slider card
        const track = document.querySelector('#product-type-slider .product-type-slider__track');
        if (track) {
          track.querySelectorAll('.product-type-slider__card').forEach(card => {
            if (card.dataset.filterValue === filterValue) {
              card.classList.remove('is-active');
              card.setAttribute('aria-pressed', 'false');
            }
          });
        }
      } else { // Uncheck corresponding checkbox
        const checkbox = container.querySelector(`input[data-filter-type="${filterType}"][data-filter-value="${filterValue}"]`);
        if (checkbox) 
          checkbox.checked = false;
        
      }

// Apply filters directly
      applyFilters();
    }

// Handle clear all filters
    if (e.target.id === 'clear-all-filters') {
      // If there are navigation tags, redirect to main collection (removing both navigation and metafield filters)
      if (Array.isArray(activeTags) && activeTags.length > 0) {
        const url = new URL(window.location.href);
        const pathParts = url.pathname.split('/');
        const collectionPart = pathParts.slice(0, -1).join('/'); // Remove the tag from path
        window.location.href = collectionPart;
        return;
      }
      
      // Check if we have any metafield, price, or product type filters in the URL
      const url = new URL(window.location.href);
      const hasMetafieldFilters = url.search.includes('filter=');
      const hasPriceFilters = url.search.includes('filter[p][price]');
      const hasProductTypeFilter = url.searchParams.has('product_type');
      
      // Clear metafield filters (checkboxes)
      container.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
        cb.checked = false;
      });

      // Clear product type slider selection
      const track = document.querySelector('#product-type-slider .product-type-slider__track');
      if (track) {
        track.querySelectorAll('.product-type-slider__card').forEach(card => {
          card.classList.remove('is-active');
          card.setAttribute('aria-pressed', 'false');
        });
      }

      // Clear price inputs
      const minInput = document.getElementById('js-price-min');
      const maxInput = document.getElementById('js-price-max');
      const mobileMinInput = document.getElementById('mobile-js-price-min');
      const mobileMaxInput = document.getElementById('mobile-js-price-max');
      if (minInput) minInput.value = '';
      if (maxInput) maxInput.value = '';
      if (mobileMinInput) mobileMinInput.value = '';
      if (mobileMaxInput) mobileMaxInput.value = '';
      
      // If we had filters and we're clearing them all, refresh the page
      if (hasMetafieldFilters || hasPriceFilters || hasProductTypeFilter) {
        const newUrl = url.pathname;
        window.location.href = newUrl;
        return;
      }

      // Apply filters directly
      applyFilters();
    }
  });

// Initial update of active filters display
  updateActiveFiltersDisplay();

// Add mobile-specific event listeners
document.addEventListener('DOMContentLoaded', function() {
  // Mobile price input listeners
  const mobileMinInput = document.getElementById('mobile-js-price-min');
  const mobileMaxInput = document.getElementById('mobile-js-price-max');
  
  if (mobileMinInput) {
    mobileMinInput.addEventListener('input', function() {
      // Sync to desktop
      const desktopMin = document.getElementById('js-price-min');
      if (desktopMin) desktopMin.value = this.value;
      applyFilters();
    });
  }
  
  if (mobileMaxInput) {
    mobileMaxInput.addEventListener('input', function() {
      // Sync to desktop
      const desktopMax = document.getElementById('js-price-max');
      if (desktopMax) desktopMax.value = this.value;
      applyFilters();
    });
  }
  
  // Mobile checkbox listeners
  document.addEventListener('change', function(e) {
    if (e.target.closest('.mobile-filters-panel') && e.target.matches('input[type="checkbox"]')) {
      const filterType = e.target.dataset.filterType;
      const filterValue = e.target.dataset.filterValue;
      
      // Sync to desktop
      const desktopCheckbox = container.querySelector(`input[data-filter-type="${filterType}"][data-filter-value="${filterValue}"]`);
      if (desktopCheckbox) {
        desktopCheckbox.checked = e.target.checked;
      }
      
      applyFilters();
    }
  });
  
  // Mobile apply filters button
  const mobileApplyBtn = document.getElementById('mobile-js-apply-filters');
  if (mobileApplyBtn) {
    mobileApplyBtn.addEventListener('click', function() {
      // Close mobile panel
      $('.mobile-filters-panel').removeClass('mobile-open');
      $('body').removeClass('filter-open');
      $('.mobile-filter-toggle span').text('Filters');
    });
  }
  
  // Mobile clear all filters
  const mobileClearBtn = document.getElementById('mobile-clear-all-filters');
  if (mobileClearBtn) {
    mobileClearBtn.addEventListener('click', function() {
      // If there are navigation tags, redirect to main collection (removing both navigation and metafield filters)
      if (Array.isArray(activeTags) && activeTags.length > 0) {
        const url = new URL(window.location.href);
        const pathParts = url.pathname.split('/');
        const collectionPart = pathParts.slice(0, -1).join('/'); // Remove the tag from path
        window.location.href = collectionPart;
        return;
      }
      
      // Check if we have any metafield, price, or product type filters in the URL
      const url = new URL(window.location.href);
      const hasMetafieldFilters = url.search.includes('filter=');
      const hasPriceFilters = url.search.includes('filter[p][price]');
      const hasProductTypeFilter = url.searchParams.has('product_type');
      
      // Clear metafield and product type filters
      container.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
        cb.checked = false;
      });
      
      const desktopMin = document.getElementById('js-price-min');
      const desktopMax = document.getElementById('js-price-max');
      if (desktopMin) desktopMin.value = '';
      if (desktopMax) desktopMax.value = '';
      
      // Clear mobile filters
      document.querySelectorAll('.mobile-filters-panel input[type="checkbox"]:checked').forEach(cb => {
        cb.checked = false;
      });
      
      const mobileMin = document.getElementById('mobile-js-price-min');
      const mobileMax = document.getElementById('mobile-js-price-max');
      if (mobileMin) mobileMin.value = '';
      if (mobileMax) mobileMax.value = '';
      
      // If we had filters and we're clearing them all, refresh the page
      if (hasMetafieldFilters || hasPriceFilters || hasProductTypeFilter) {
        const newUrl = url.pathname;
        window.location.href = newUrl;
        return;
      }
      
      // Apply filters
      applyFilters();
    });
  }
  
  // Mobile remove filter
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('remove-filter') && e.target.closest('.mobile-filters-panel')) {
      const filterType = e.target.dataset.filterType;
      const filterValue = e.target.dataset.filterValue;

      if (filterType === 'navigation') {
        // For navigation tags, redirect to the main collection but preserve metafield filters
        const url = new URL(window.location.href);
        const pathParts = url.pathname.split('/');
        const collectionPart = pathParts.slice(0, -1).join('/'); // Remove the tag from path
        
        // Preserve existing metafield filters in query parameters
        const params = new URLSearchParams(url.search);
        const newUrl = params.toString() ? `${collectionPart}?${params.toString()}` : collectionPart;
        
        window.location.href = newUrl;
        return;
      } else if (filterType === 'price') {
        const desktopMin = document.getElementById('js-price-min');
        const desktopMax = document.getElementById('js-price-max');
        const mobileMin = document.getElementById('mobile-js-price-min');
        const mobileMax = document.getElementById('mobile-js-price-max');
        
        if (desktopMin) desktopMin.value = '';
        if (desktopMax) desktopMax.value = '';
        if (mobileMin) mobileMin.value = '';
        if (mobileMax) mobileMax.value = '';
      } else if (filterType === 'producttype') {
        const track = document.querySelector('#product-type-slider .product-type-slider__track');
        if (track) {
          track.querySelectorAll('.product-type-slider__card').forEach(card => {
            if (card.dataset.filterValue === filterValue) {
              card.classList.remove('is-active');
              card.setAttribute('aria-pressed', 'false');
            }
          });
        }
      } else {
        const desktopCheckbox = container.querySelector(`input[data-filter-type="${filterType}"][data-filter-value="${filterValue}"]`);
        const mobileCheckbox = document.querySelector(`.mobile-filters-panel input[data-filter-type="${filterType}"][data-filter-value="${filterValue}"]`);
        
        if (desktopCheckbox) desktopCheckbox.checked = false;
        if (mobileCheckbox) mobileCheckbox.checked = false;
      }
      
      applyFilters();
    }
  });
});

// Function to calculate filter counts based on current products
function calculateFilterCounts(products, activeTags, excludeCheckedFilters = []) {
  // First, filter products by navigation tags (case-insensitive for URL vs product tag mismatch)
  let filteredProducts = products;
  if (activeTags.length > 0 && products?.length > 0) {
    filteredProducts = products.filter(({node}) => {
      return node.tags && activeTags.some(tag =>
        node.tags.some(t => (t || '').toLowerCase() === (tag || '').toLowerCase())
      );
    });
  }
  
  // Then, any currently checked filters (excluding the one we're counting)
  if (excludeCheckedFilters.length > 0) {
    filteredProducts = filteredProducts.filter(({node}) => {
      return excludeCheckedFilters.every(filter => {
        if (filter.type === 'producttype') {
          return node.productType && node.productType === filter.value;
        }
        if (node.metafields && Array.isArray(node.metafields)) {
          const metafield = node.metafields.find(m => m && m.key === `filter_${filter.type}`);
          if (metafield && metafield.value) {
            let metafieldValues;
            let filterValues;
            
            // Handle JSON-encoded values
            try {
              const parsed = JSON.parse(metafield.value);
              metafieldValues = Array.isArray(parsed) ? parsed : metafield.value.split(',').map(v => v.trim());
            } catch (e) {
              metafieldValues = metafield.value.split(',').map(v => v.trim());
            }
            
            try {
              const parsed = JSON.parse(filter.value);
              filterValues = Array.isArray(parsed) ? parsed : filter.value.split(',').map(v => v.trim());
            } catch (e) {
              filterValues = filter.value.split(',').map(v => v.trim());
            }
            
            return filterValues.some(fv => metafieldValues.includes(fv));
          }
        }
        return false;
      });
    });
  }
  
  // Calculate counts for each filter type
  const counts = {
    material: {},
    color: {},
    design: {},
    productType: {}
  };
  
  filteredProducts.forEach(({node}) => {
    if (node.metafields && Array.isArray(node.metafields)) {
      node.metafields.forEach(metafield => {
        if (metafield && metafield.value) {
          let values;
          
          // Handle JSON-encoded values (like "[\"Wool & Linen & Silk\"]")
          try {
            const parsed = JSON.parse(metafield.value);
            if (Array.isArray(parsed)) {
              values = parsed;
            } else {
              values = metafield.value.split(',').map(v => v.trim());
            }
          } catch (e) {
            // If JSON parsing fails, treat as comma-separated
            values = metafield.value.split(',').map(v => v.trim());
          }
          
          values.forEach(value => {
            if (value) {
              switch (metafield.key) {
                case 'filter_material':
                  counts.material[value] = (counts.material[value] || 0) + 1;
                  break;
                case 'filter_color':
                  counts.color[value] = (counts.color[value] || 0) + 1;
                  break;
                case 'filter_design':
                  counts.design[value] = (counts.design[value] || 0) + 1;
                  break;
              }
            }
          });
        }
      });
        }
        if (node.productType) {
          const pt = node.productType.trim();
          if (pt && !pt.toLowerCase().includes('samples') && !pt.toLowerCase().includes('services')) {
            counts.productType[pt] = (counts.productType[pt] || 0) + 1;
          }
        }
  });
  
  return counts;
}

// Function to get currently checked filters (includes product type from slider)
function getCheckedFilters() {
  const result = [];
  const checkedInputs = container.querySelectorAll('input[type="checkbox"]:checked');
  checkedInputs.forEach(cb => {
    if (cb.dataset.filterType && cb.dataset.filterValue) {
      result.push({ type: cb.dataset.filterType, value: cb.dataset.filterValue });
    }
  });
  const activeProductType = getActiveProductTypeFromSlider();
  if (activeProductType) {
    result.push({ type: 'producttype', value: activeProductType });
  }
  return result;
}

// Function to update filter counts
function updateFilterCounts(productData = null) {
  // If productData contains fresh facet filters, update our snapshot now
  const incomingFilters = productData?.data?.collectionByHandle?.products?.filters;
  if (incomingFilters && Array.isArray(incomingFilters)) {
    currentServerFilters = normalizeAndCombineFilters(incomingFilters);
  }
  // Prefer currentServerFilters if available
  if (currentServerFilters && currentServerFilters.length > 0) {
    updateFilterCountsWithServerData();
    return;
  }
  
  // Fallback to GraphQL data if server-side filters not available
  if (productData) {
    // Use the product data we already have from GraphQL
    const products = productData.data?.collectionByHandle?.products?.edges;
    if (products) {
      updateFilterCountsWithProducts(products);
      return;
    }
  }
  
  // If no product data provided, use the facet data we have globally
  if (window.facetData) {
    const products = window.facetData.collectionByHandle?.products?.edges;
    if (products) {
      updateFilterCountsWithProducts(products);
      return;
    }
  }
  
  // Fallback: fetch products if we don't have them
  fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': token
    },
    body: JSON.stringify({query: productQuery, variables: {handle}})
  })
  .then(res => res.json())
  .then(json => {
    const products = json.data?.collectionByHandle?.products?.edges;
    if (products) {
      updateFilterCountsWithProducts(products);
    }
  })
  .catch(err => console.error('Error fetching products for count update:', err));
}

// Function to update filter counts using server-side collection filters
function buildFiltersExcludingType(excludeType) {
  const filters = [];
  // navigation tags
  if (Array.isArray(activeTags)) {
    activeTags.forEach(tag => {
      if (!tag.includes('filter_')) {
        filters.push({ tag });
      }
    });
  }
  // checked metafields and product type (except the excluded type)
  const checked = getCheckedFilters();
  checked.forEach(f => {
    if (!f.type || !f.value || f.type === excludeType) return;
    if (f.type === 'producttype') {
      filters.push({ productType: f.value });
    } else {
      filters.push({
        productMetafield: {
          namespace: "custom",
          key: `filter_${f.type}`,
          value: f.value
        }
      });
    }
  });
  // price - GraphQL requires Decimal (string format)
  const minInput = document.getElementById('js-price-min');
  const maxInput = document.getElementById('js-price-max');
  const minVal = parseFloat(minInput ?. value);
  const maxVal = parseFloat(maxInput ?. value);
  if (!isNaN(minVal) || !isNaN(maxVal)) {
    filters.push({
      price: { 
        min: isNaN(minVal) ? "0.00" : minVal.toFixed(2), 
        max: isNaN(maxVal) ? "999999.00" : maxVal.toFixed(2) 
      }
    });
  }
  return filters;
}

function updateFilterCountsWithServerData() {
  const checkedFilters = getCheckedFilters();
  
  // Update each filter type
  ['material', 'color', 'design'].forEach(filterType => {
    // Find the corresponding server-side filter
    const serverSideFilter = (currentServerFilters || []).find(f => 
      f && f.label && (
        f.label.toLowerCase() === filterType || 
        (filterType === 'material' && f.label === 'Material') ||
        (filterType === 'color' && f.label === 'Color') ||
        (filterType === 'design' && f.label === 'Design')
      )
    );
    
    // Update desktop filters
    const filterContainer = container.querySelector(`#${filterType === 'material' ? 'fabric-filters' : filterType === 'color' ? 'color-filters' : 'pattern-filters'}`);
    if (filterContainer && serverSideFilter) {
      const checkboxes = filterContainer.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(cb => {
        const filterValue = cb.dataset.filterValue;
        if (filterValue) {
          // Find the corresponding server-side value by matching the label (case-insensitive)
          const labelText = cb.parentElement.textContent.split(' (')[0].trim();
          const serverSideValue = serverSideFilter.values.find(v => 
            (v.label || '').trim().toLowerCase() === labelText.toLowerCase()
          );
          
          let filterCount = 0;
          const otherFilters = checkedFilters.filter(f => f.type !== filterType);
          if (otherFilters.length > 0) {
            // Fetch products filtered by navigation + other filters (excluding this type)
            const filters = buildFiltersExcludingType(filterType);
            // We'll compute counts after the fetch returns
            fetch(endpoint, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': token
              },
              body: JSON.stringify({ query: productQuery, variables: { handle, filters } })
            })
            .then(res => res.json())
            .then(json => {
              if (json.errors) {
                console.error('GraphQL product errors (count compute):', json.errors);
                return;
              }
              const products = json?.data?.collectionByHandle?.products?.edges || [];
              const counts = calculateFilterCounts(products, activeTags, []);
              const countKey = filterType === 'material' ? 'material' : filterType === 'color' ? 'color' : 'design';
              let vals;
              try {
                const parsed = JSON.parse(filterValue);
                vals = Array.isArray(parsed) ? parsed : filterValue.split(',').map(v => v.trim());
              } catch (e) {
                vals = filterValue.split(',').map(v => v.trim());
              }
              let total = 0;
              vals.forEach(val => { if (counts[countKey] && counts[countKey][val]) total += counts[countKey][val]; });
              filterCount = total;
              // Update the label text now that we have accurate count
              const label = cb.parentElement;
              if (label) {
                const baseText = label.textContent.split(' (')[0];
                const isDisabled = filterCount === 0;
                const sameTypeSelected = checkedFilters.some(filter => filter.type === filterType && filter.value !== cb.dataset.filterValue);
                const shouldDisable = isDisabled || sameTypeSelected;
                const disabledClass = shouldDisable ? 'disabled' : '';
                const disabledAttr = shouldDisable ? 'disabled' : '';
                label.innerHTML = `
                  <input type="checkbox" 
                         data-filter-type="${cb.dataset.filterType}" 
                         data-filter-value="${cb.dataset.filterValue}"
                         ${cb.checked ? 'checked' : ''}
                         ${disabledAttr}>
                    ${baseText} (${filterCount})
                `;
                label.className = disabledClass;
              }
            })
            .catch(err => console.error('Error computing counts for', filterType, err));
            return; // Defer updating until fetch completes
          } else if (serverSideValue) {
            // No other filters selected, use the server-side count
            filterCount = serverSideValue.count || 0;
          }
          
          // Update the label text
          const label = cb.parentElement;
          if (label) {
            const labelText = label.textContent.split(' (')[0]; // Get text without count
            const isDisabled = filterCount === 0;
            
            // Check if another filter of the same type is already selected
            const checkedFilters = getCheckedFilters();
            const hasOtherFilterOfSameType = checkedFilters.some(filter => 
              filter.type === filterType && filter.value !== cb.dataset.filterValue
            );
            
            // Disable if count is 0 OR if another filter of the same type is selected
            const shouldDisable = isDisabled || hasOtherFilterOfSameType;
            const disabledClass = shouldDisable ? 'disabled' : '';
            const disabledAttr = shouldDisable ? 'disabled' : '';
            
            label.innerHTML = `
              <input type="checkbox" 
                     data-filter-type="${cb.dataset.filterType}" 
                     data-filter-value="${cb.dataset.filterValue}"
                     ${cb.checked ? 'checked' : ''}
                     ${disabledAttr}>
                ${labelText} (${filterCount})
            `;
            label.className = disabledClass;
          }
        }
      });
    }
    
    // Update mobile filters
    const mobileFilterContainer = document.querySelector(`#mobile-${filterType === 'material' ? 'material' : filterType === 'color' ? 'color' : 'design'}-filters`);
    if (mobileFilterContainer && serverSideFilter) {
      const mobileCheckboxes = mobileFilterContainer.querySelectorAll('input[type="checkbox"]');
      mobileCheckboxes.forEach(cb => {
        const filterValue = cb.dataset.filterValue;
        if (filterValue) {
          // Find the corresponding server-side value by matching the label (case-insensitive)
          const labelText = cb.parentElement.textContent.split(' (')[0].trim();
          const serverSideValue = serverSideFilter.values.find(v => 
            (v.label || '').trim().toLowerCase() === labelText.toLowerCase()
          );
          
          let filterCount = 0;
          if (serverSideValue) {
            // If we have other filters selected, we need to calculate the filtered count
            const otherFilters = checkedFilters.filter(f => f.type !== filterType);
            if (otherFilters.length > 0) {
              // Use GraphQL data to calculate filtered counts
              if (window.facetData) {
                const products = window.facetData.collectionByHandle?.products?.edges;
                if (products) {
                  const excludeFilters = otherFilters;
                  const counts = calculateFilterCounts(products, activeTags, excludeFilters);
                  
                  // Get the count for this specific filter value
                  const countKey = filterType === 'material' ? 'material' : 
                                  filterType === 'color' ? 'color' : 
                                  filterType === 'design' ? 'design' : null;
                  
                  if (countKey) {
                    // Parse the filter value to get individual values
                    let filterValues;
                    try {
                      const parsed = JSON.parse(filterValue);
                      filterValues = Array.isArray(parsed) ? parsed : filterValue.split(',').map(v => v.trim());
                    } catch (e) {
                      filterValues = filterValue.split(',').map(v => v.trim());
                    }
                    
                    filterValues.forEach(val => {
                      if (counts[countKey] && counts[countKey][val]) {
                        filterCount += counts[countKey][val];
                      }
                    });
                  }
                }
              }
            } else {
              // No other filters selected, use the server-side count
              filterCount = serverSideValue.count || 0;
            }
          }
          
          // Update the label text
          const label = cb.parentElement;
          if (label) {
            const labelText = label.textContent.split(' (')[0]; // Get text without count
            const isDisabled = filterCount === 0;
            
            // Check if another filter of the same type is already selected
            const checkedFilters = getCheckedFilters();
            const hasOtherFilterOfSameType = checkedFilters.some(filter => 
              filter.type === filterType && filter.value !== cb.dataset.filterValue
            );
            
            // Disable if count is 0 OR if another filter of the same type is selected
            const shouldDisable = isDisabled || hasOtherFilterOfSameType;
            const disabledClass = shouldDisable ? 'disabled' : '';
            const disabledAttr = shouldDisable ? 'disabled' : '';
            
            label.innerHTML = `
              <input type="checkbox" 
                     data-filter-type="${cb.dataset.filterType}" 
                     data-filter-value="${cb.dataset.filterValue}"
                     ${cb.checked ? 'checked' : ''}
                     ${disabledAttr}>
                ${labelText} (${filterCount})
            `;
            label.className = disabledClass;
          }
        }
      });
    }
  });
}

// Function to update filter counts with product data
function updateFilterCountsWithProducts(products) {
  const checkedFilters = getCheckedFilters();
  
  // Update each filter type
  ['material', 'color', 'design'].forEach(filterType => {
    const excludeFilters = checkedFilters.filter(f => f.type !== filterType);
    const counts = calculateFilterCounts(products, activeTags, excludeFilters);
    
    // Update desktop filters
    const filterContainer = container.querySelector(`#${filterType === 'material' ? 'fabric-filters' : filterType === 'color' ? 'color-filters' : 'pattern-filters'}`);
    if (filterContainer) {
      const checkboxes = filterContainer.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(cb => {
        const filterValue = cb.dataset.filterValue;
        if (filterValue) {
          const values = filterValue.split(',').map(v => v.trim());
          let filterCount = 0;
          
          values.forEach(val => {
            if (counts[filterType] && counts[filterType][val]) {
              filterCount += counts[filterType][val];
            }
          });
          
          // Update the label text
          const label = cb.parentElement;
          if (label) {
            const labelText = label.textContent.split(' (')[0]; // Get text without count
            const isDisabled = filterCount === 0;
            
            // Check if another filter of the same type is already selected
            const checkedFilters = getCheckedFilters();
            const hasOtherFilterOfSameType = checkedFilters.some(filter => 
              filter.type === filterType && filter.value !== cb.dataset.filterValue
            );
            
            // Disable if count is 0 OR if another filter of the same type is selected
            const shouldDisable = isDisabled || hasOtherFilterOfSameType;
            const disabledClass = shouldDisable ? 'disabled' : '';
            const disabledAttr = shouldDisable ? 'disabled' : '';
            
            label.innerHTML = `
              <input type="checkbox" 
                     data-filter-type="${cb.dataset.filterType}" 
                     data-filter-value="${cb.dataset.filterValue}"
                     ${cb.checked ? 'checked' : ''}
                     ${disabledAttr}>
                ${labelText} (${filterCount})
            `;
            label.className = disabledClass;
          }
        }
      });
    }
    
    // Update mobile filters
    const mobileFilterContainer = document.querySelector(`#mobile-${filterType === 'material' ? 'material' : filterType === 'color' ? 'color' : 'design'}-filters`);
    if (mobileFilterContainer) {
      const mobileCheckboxes = mobileFilterContainer.querySelectorAll('input[type="checkbox"]');
      mobileCheckboxes.forEach(cb => {
        const filterValue = cb.dataset.filterValue;
        if (filterValue) {
          const values = filterValue.split(',').map(v => v.trim());
          let filterCount = 0;
          
          values.forEach(val => {
            if (counts[filterType] && counts[filterType][val]) {
              filterCount += counts[filterType][val];
            }
          });
          
          // Update the label text
          const label = cb.parentElement;
          if (label) {
            const labelText = label.textContent.split(' (')[0]; // Get text without count
            const isDisabled = filterCount === 0;
            
            // Check if another filter of the same type is already selected
            const checkedFilters = getCheckedFilters();
            const hasOtherFilterOfSameType = checkedFilters.some(filter => 
              filter.type === filterType && filter.value !== cb.dataset.filterValue
            );
            
            // Disable if count is 0 OR if another filter of the same type is selected
            const shouldDisable = isDisabled || hasOtherFilterOfSameType;
            const disabledClass = shouldDisable ? 'disabled' : '';
            const disabledAttr = shouldDisable ? 'disabled' : '';
            
            label.innerHTML = `
              <input type="checkbox" 
                     data-filter-type="${cb.dataset.filterType}" 
                     data-filter-value="${cb.dataset.filterValue}"
                     ${cb.checked ? 'checked' : ''}
                     ${disabledAttr}>
                ${labelText} (${filterCount})
            `;
            label.className = disabledClass;
          }
        }
      });
    }
  });
}

// Function to calculate filter counts from server-side rendered products
function calculateFilterCountsFromServerRendered(activeTags, excludeCheckedFilters = []) {
  // This function is no longer used - we now always fetch GraphQL data for accurate counts
  return {
    material: {},
    color: {},
    design: {}
  };
}

// Function to normalize and combine duplicate filter values
function normalizeAndCombineFilters(filters) {
  const normalizedFilters = [];
  
  filters.forEach(filter => {
    if (filter.type === 'LIST') {
      const combinedByKey = new Map(); // key: lowercased label, value: {label, count, inputs}
      
      filter.values.forEach(value => {
        const rawLabel = (value.label || '').trim();
        const key = rawLabel.toLowerCase();
        
        // Preserve original label casing from the first occurrence
        const existing = combinedByKey.get(key) || {label: rawLabel, count: 0, inputs: []};
        existing.count += (value.count || 0);
        existing.inputs.push(value.input);
        combinedByKey.set(key, existing);
      });
      
      const combinedValues = [];
      combinedByKey.forEach(({label, count, inputs}) => {
        // Prefer the first input payload (it contains the productMetafield we need)
        let inputPayload = inputs[0];
        try {
          const parsed = JSON.parse(inputPayload);
          // Ensure input payload keeps original casing/value
          inputPayload = JSON.stringify(parsed);
        } catch (e) {
          // leave as-is if not JSON
        }
        combinedValues.push({ label, count, input: inputPayload });
      });
      
      normalizedFilters.push({ ...filter, values: combinedValues });
    } else {
      normalizedFilters.push(filter);
    }
  });
  
  return normalizedFilters;
}
})();